export const LIST = "DELAY_BONUS_LISTING";
export const DROPDOWN = "DELAY_BONUS_DROPDOWN";
export const DETAILS = "DELAY_BONUS_DETAILS";
export const UPDATE = "DELAY_BONUS_UPDATE";
export const UPDATE_STATUS = "DELAY_BONUS_UPDATE_STATUS";
